// ServicesSection.jsx
import React from 'react';
import './ServicesSection.css';
import { Card, CardContent } from './ui/card';
import { Headphones, Code, Wrench, Lightbulb } from 'lucide-react';
import { mockServices } from './mock';

const iconMap = {
  Headphones,
  Code,
  Wrench,
  Lightbulb,
};

const ServicesSection = () => {
  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <div className="services-header">
          <div className="services-badge">Our Services</div>
          <h2 className="services-title">
            Complete Technical Support
            <span className="highlighted-text"> Solutions</span>
          </h2>
          <p className="services-description">
            From IT helpdesk to hardware repair, we provide comprehensive technical support services to keep your business running smoothly.
          </p>
        </div>

        <div className="services-grid">
          {mockServices.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card key={service.id} className="service-card">
                <CardContent className="service-card-content">
                  <div className="service-icon-wrapper">
                    <IconComponent className="service-icon" />
                  </div>
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-text">{service.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
